import { useContext, useEffect, useState } from "react";
import { RouteContext } from "../../contexts/RoutesContext";
import { InfoBanner, InfoHeaderIcon } from "../components/Shared/InfoBanner";
import { Colour } from "../Variables";
import { AccountSecurityModel, API_AccountSecurityStatus, MfaStateModel } from "../../apis/ApisAccountSecurity";
import { AppContext } from "../../contexts/AppContext";
import { AccountSecurityCard } from "../components/Other/AccountSecurityCard";
import { LoadingContent } from "../components/Shared/LoadingContent";
import { Link } from "react-router";
import { SetupAppMFAForm } from "../components/Forms/SetupAppMFAForm";
import { SetupSmsMFAForm } from "../components/Forms/SetupSmsMFAForm";

export function AccountSecurity() {
    const app = useContext(AppContext);
    const routeContext = useContext(RouteContext);
    const [data, setData] = useState<AccountSecurityModel>(null);
    const [emailData, setEmailData] = useState<MfaStateModel>(null);
    const [appData, setAppData] = useState<MfaStateModel>(null);
    const [smsData, setSmsData] = useState<MfaStateModel>(null);

    const reload = async () => {
        var accData = await API_AccountSecurityStatus();
        setData(accData);
        setEmailData(accData.MfaStates.find(x => x.Type.Type == "Email"));
        setAppData(accData.MfaStates.find(x => x.Type.Type == "App"));
        setSmsData(accData.MfaStates.find(x => x.Type.Type == "Sms"));
    }

    const loadData = async () => {
        await reload();
    }

    useEffect(() => {
        if (!app.loading && app.userLoggedIn) {
            routeContext.setRoutes([{ name: "Positions", route: null }]);

        } else if (!app.loading && !app.userLoggedIn) {
            routeContext.setRoutes([]);
        }

        if (!app.loading) {
            loadData();
        }

    }, [app.loading]);

    useEffect(() => {
        routeContext.setRoutes([{ name: "Account security", route: null }])
    }, []);

    return (
        <div className="mb-3">
            <InfoBanner
                narrow={true}
                header="Account security"
                icon={InfoHeaderIcon.Padlock}
                info={""}
                subHeader={`Manage multi-factor authentication security`}
                theme={Colour.White}>
            </InfoBanner>

            <LoadingContent loading={data == null} classes={"w-100"}>
                {data != null && emailData != null && <AccountSecurityCard title="Email" icon="fa-solid fa-envelope" inUse={emailData.UserMFAVerified} buttonkey={"Email"} key={"Email"}>
                    <div className="card-body">
                        <h5 className="text-alt-or-contrast">Email authentication will always be active</h5>
                        <p>You have email authentication active. Codes will be sent to the email address configured</p>
                        <Link className="btn btn-outline-soft" to="/PersonalDetails">Personal details</Link>
                    </div>
                </AccountSecurityCard>}

                {data != null && appData != null && (data.Features.MFA_App || appData.UserMFAVerified) &&
                    <AccountSecurityCard title="App" icon="fa-solid fa-mobile-screen-button" inUse={appData.UserMFAVerified} buttonkey={"App"} key={"App"} >
                        <div className="card-body">
                            <SetupAppMFAForm baseState={appData} reload={reload} />
                        </div>

                    </AccountSecurityCard>
                }

                {data != null && smsData != null && (data.Features.MFA_Sms || smsData.UserMFAVerified) &&
                    <AccountSecurityCard title="Sms" icon="fa-solid fa-comment-sms" inUse={smsData.UserMFAVerified} buttonkey={"Sms"} key={"Sms"}>
                        <div className="card-body">
                            {data.HasAcceptedPhoneNumber ? <SetupSmsMFAForm baseState={smsData} reload={reload} /> : <>
                                <h5>Sms authentication requires a valid phone number</h5>
                                <p>Please provide a valid mobile phone number in your personal details.</p>
                                <Link className="btn btn-outline-soft" to="/PersonalDetails">Personal details</Link>
                            </>}
                        </div>
                    </AccountSecurityCard>
                }
            </LoadingContent>
        </div>
    );
}